module.exports = __webpack_public_path__ + "static/media/Турганов Н..dcd9778a.pdf";